let language = {
    "BASE_UNHANDLE_ERROR_TITLE": "发生未知错误",
    "BASE_UNHANDLE_ERROR_CONTENT": "发生了一个未知错误，请刷新页面并重试。如果问题仍然存在，请联系技术支持 {{supportmail}}。",
    
    "SYSTEM_ERROR_TITLE": "连接失败",
    "SYSTEM_ERROR_CONTENT": "在尝试将数据传递到服务器时连接失败。请检查您的网络连接。或者，您可以刷新此页面并重试。如果问题仍然存在，请联系技术支持 {{supportmail}}。",
    
    "MISSING_AUTHENTICATION_TITLE": "缺少认证",
    "MISSING_AUTHENTICATION_CONTENT": "您没有认证或认证已过期，点击 [确定] 重新登录，或点击 [取消] 以匿名用户身份访问此页面。",
    "MISSING_AUTHORIZED_AUTHENTICATION_CONTENT": "您没有认证或认证已过期，点击 [确定] 重新登录。",
    
    "LACKING_PERMISSION_TITLE": "缺乏权限",
    "LACKING_PERMISSION_CONTENT": "您没有权限，请点击[确定]重新登录。",
    
    "NETWORK_CONNECTION_TIMEOUT_TITLE": "网络连接超时",
    "NETWORK_CONNECTION_TIMEOUT_CONTENT": "网络波动导致请求超时。请稍后再试。",
    
    "NETWORK_UNAVAILABLE_TITLE": "没有互联网连接",
    "NETWORK_UNAVAILABLE_CONTENT": "您的网络不可用，请检查您的数据或Wi-Fi连接。",
    
    "UNEXPECTED_ERROR_TITLE": "发生错误",
    "UNEXPECTED_ERROR_CONTENT": "发生了错误，请刷新页面并重试。",
}

export { language }
